import { useAppSelector } from '../../store/hooks';
import AccountSummaryHero from './AccountSummaryHero';
import CoverageSection from './CoverageSection';
import QuickLinks from './QuickLinks';
import WeatherAssurance from './WeatherAssurance';
import { getHomeAuthedSummary } from './policyBundleSummary';
import { getFirstName, getGreeting } from './personalization';
import styles from './home-authed.module.scss';

const HomeAuthed: React.FC = () => {
  const { policyBundles, ready: policyBundlesReady } = useAppSelector(
    (state) => state.policyBundles,
  );
  const user = useAppSelector((state) => state.user.user);
  const now = new Date();
  const summary = getHomeAuthedSummary(policyBundles, now);

  return (
    <main className={styles.root}>
      <AccountSummaryHero
        greeting={getGreeting(now)}
        firstName={getFirstName(user.name)}
        coveredTripsCount={summary.coveredTripsCount}
        activeClaimsCount={summary.activeClaimsCount}
        openClaimsCount={summary.openClaimsCount}
      />
      <CoverageSection
        policyBundlesReady={policyBundlesReady}
        featuredBundle={summary.featuredBundle}
        isCurrent={summary.isCurrent}
      />
      <QuickLinks />
      <WeatherAssurance />
    </main>
  );
};

export default HomeAuthed;
